import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailsComponent } from './details.component';
import { RouterModule } from '@angular/router';
import { detailsRoutes } from './details.routes';
import { TranslateModule } from '@ngx-translate/core';
import { LayoutModule } from '../shared/layout/layout.module';
import { EventDetailsComponent } from './event-details/event-details.component';
import { CallDetailsComponent } from './call-details/call-details.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [CommonModule, RouterModule.forChild(detailsRoutes), TranslateModule, LayoutModule, SharedModule],
  exports: [],
  declarations: [DetailsComponent, EventDetailsComponent, CallDetailsComponent]
})
export class DetailsModule {}
